export default __webpack_public_path__ + "static/media/10_pc@2x.4be08b9c.png";